<template>
   <label :for="fieldData.name" 
      class="classLabel col-12 px-0 pt-1">{{ fieldData.label }}</label>
   <Field :name="fieldData.name" 
      :type="fieldData.type" 
      class="form-control col-12 py-0 px-1" 
      :tabindex="tabindex"
      :id="id"
      :readonly="readonly"
      @blur="$emit('onBlur')"
      @focus="$emit('onFocus')"
      />
   <div class="col-12 text-end fst-italic fs-14">
      <ErrorMessage :name="fieldData.name" 
         class="error-feedback" />
   </div>
</template>

<script>
import { Field, ErrorMessage } from "vee-validate";

export default {
   name: 'CommonField01',
   components: {
      Field,
      ErrorMessage,
   },
   props: {
      fieldData: {
         type: Object,
         required: true,
      },
      id: { 
         type: String,
         default: 'text'
      },
      tabindex: { type: Number },
      readonly: {
         type: Boolean,
         default: false
      },
   },
   emits: [ 'onBlur', 'onFocus' ],
   /*
   setup() {
      return {
      :rules="fieldData.rules" 

      :tabindex="fieldData.tabindex"
      :id="fieldData.name"
      }
   }
   */
}
</script>

<style>
.fs-14 {
   font-size: 14px;
}
</style>